export default __webpack_public_path__ + "static/media/fixture2_table.29d8a68e.png";